import React,{useState, useEffect} from 'react';
import { FiBarChart } from 'react-icons/fi';
import SeleccionaFecha from '../components/DatePicker/SeleccionaFecha';
import {getSolicitudesFiltros} from "../services/Solicitudes";
import { useStateContext } from '../contexts/ContextProvider';

import DataTable from 'react-data-table-component';
import { subMonths, startOfMonth } from 'date-fns';

const Ecommerce = () => {
  const { currentColor, currentMode } = useStateContext();
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [idCliente, setIdCliente] = useState('ALL');
  const [allData, setAllData] = useState([]);

  const [estado, setEstado] = useState('ALL');
  const [tipoSolicitud, setTipoSolicitud] = useState('ALL');

  const [documentosData, setDocumentosData] = useState([]);

  const [totalDash, setTotalDash] = useState(0);


    useEffect(()=>{
      const fetchData = async () => {
  
        const soliciData = await getSolicitudesFiltros(selectedDate.toISOString(),selectedDateEnd.toISOString(),tipoSolicitud,estado );
        setAllData(soliciData);
  
        // Obtener el Gran Total sumando todos los valores de 'total'
        const granTotal = soliciData.length;

        setTotalDash(granTotal);

        const sumaPorEstado = soliciData.reduce((accumulator, { estado, total }) => {
          accumulator[estado] = (accumulator[estado] || 0) + 1;
          return accumulator;
        }, {});

        // Convertir el objeto en un array de objetos
        const arrayResultado = Object.entries(sumaPorEstado).map(([estado, total]) => ({ estado, total }));

        setDocumentosData(arrayResultado);

      };
      fetchData();
      // rutCliPro,razonSocial
    },[selectedDate,selectedDateEnd,tipoSolicitud,estado]); 

    const handleChangeEstado = (e) =>{
      setEstado( e.target.value );
    }
  
    const handleChangeTipoSolicitud = (e) =>{
      setTipoSolicitud( e.target.value );
    }

    const calcularPrimerDiaMesAnterior = (startDate) => {
      // Parsea la fecha de inicio
      const fechaInicio = new Date(startDate);
      
      // Obtiene el primer día del mes anterior
      const primerDiaMesAnterior = startOfMonth(subMonths(fechaInicio, 1));
      
      // Formatea la fecha al formato deseado (ej. 01-09-2023)
      const formatoFecha = `${primerDiaMesAnterior.getFullYear()}${('0' + (primerDiaMesAnterior.getMonth() + 1)).slice(-2)}${('0' + primerDiaMesAnterior.getDate()).slice(-2)}`;
    
      return formatoFecha;
    };
    
    const cambiaFecha = (startDate) => {
      // Parsea la fecha de inicio
      const fechaInicio = new Date(startDate);
      
      // Formatea la fecha al formato deseado (ej. 01-09-2023)
      const formatoFecha = `${fechaInicio.getFullYear()}${('0' + (fechaInicio.getMonth() + 1)).slice(-2)}${('0' + fechaInicio.getDate()).slice(-2)}`;
    
      return formatoFecha;
    };

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  const handleChange = (e) =>{
    setIdCliente( e.target.value );
  }

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
      },
    },
    headRow: {
      style: {
        backgroundColor: 'white',
        fontSize: 12,
        borderRadius: 8,
        fontWeight: '400',
        color: '#AEB2D7',
        borderWidth: 0,
        textAlign: 'center',
        headerStyles:{
          backgroundColor: '#F2F5FE',
          fontWeight: 'bold',
          color: '#2F336A',
        },
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        margin: '4px 0px',
        backgroundColor: 'white',
        borderRadius: 8,
        fontSize: 10,
        rowStyles:{
          borderBottom: 1,
        }
      },
    },
  };

  const columnsFiados = [
    {
      name: 'Estado Documento',
      selector: row => row.estado,
      sortable: true
    },
    {
      name: 'Cantidad',
      selector: row => row.total,
      sortable: true
    }
  ];

  return (
    <>
    <div className="flex flex-wrap lg:flex-nowrap mt-16">
      <div className="flex flex-wrap lg:flex-nowrap justify-center ">
        <div className="flex m-3 flex-wrap justify-center gap-1 items-center">
            <div className= "flex justify-evenly space-x-6 bg-white  w-full dark:text-gray-200 dark:bg-secondary-dark-bg  p-4 pt-9 rounded-2xl ">
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDate}
                    handleDateChange={handleDateChange}
                  />
                </div>
                <div>
                  <SeleccionaFecha
                    selectedDate={selectedDateEnd}
                    handleDateChange={handleDateChangeEnd}
                  />
                </div>

                <div>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="tipoSolicitud" value= {tipoSolicitud} required onChange={handleChangeTipoSolicitud}>   
                  <option value="ALL">Todos</option>
                  <option value="Entrada">Entrada</option>
                  <option value="Salida">Salida</option>  
                  <option value="Adicional">Adicional</option>   
                  <option value="Reemplazo">Reemplazo</option>    
                  </select>
                </div>
                <div>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value= {estado} required onChange={handleChangeEstado}>   
                  <option value="ALL">Todos</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="En Proceso">En Proceso</option>  
                  <option value="Aprobada">Aprobada</option>
                  <option value="Rechazada">Rechazada</option>      
                  </select>
                </div>
                
            </div>
        </div>
      </div>
    </div>

    <div className="bg-[#fff4e5] dark:text-gray-200 dark:bg-secondary-dark-bg  p-4 pt-9 rounded-2xl ">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >
                <div className="flex flex-col">
                    <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg md:w-56  p-4 pt-9 rounded-2xl ">
                    <div className="flex flex-col-2">
                      <div>
                        <button
                          type="button"
                          style={{ color: 'rgb(228, 106, 118)', backgroundColor: 'rgb(255, 244, 229)' }}
                          className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl"
                        >
                          <FiBarChart />
                        </button>
                        <p className="mt-3">
                          <span className="text-lg text-blue-800 font-semibold">{totalDash}</span>
                        </p>  
                      </div>

                  </div>
                  <p className="text-sm text-gray-400  mt-1">Solicitudes</p>
                </div>  
                </div>
                <div className="col-span-3">
                  <div className="flex flex-col">
                    <DataTable
                    columns={columnsFiados}
                    data={documentosData}
                    highlightonhover
                    striped
                    className="border border-gray-300 rounded-lg shadow-sm"
                    noHeader={true}
                    selectablerowshighlight
                    customStyles={customStyles}
                    noDataComponent={'No hay Solicitudes.'}
                    />
                  </div>
                </div>
        </div>
    </div>

</>

  );
};

export default Ecommerce;